import React, { useState, useEffect } from 'react';

import { ContentBox } from '../ContentBox';
import { setVal2Token, getUserInfoCompanyId, getval2Token } from '../../../Login/Auth';
import { CancelButton, SearchButton, SingleLink, EnableBadge, Space, AddButton } from '../../Res/BaseButton';
import moment from 'moment';
import { SystemPromptInput } from '../../Res/SystemPrompt';
import { SingleInput, SingleSelect } from '../../Res/BaseInput';
import { Pagination } from '../../Res/Pagination';
import { api_getSkill } from '../../../../api/apiResume';
import { api_getRecruitmentContractorStatusList } from '../../../../api/apiRecruitmentContractorStatus';
import { ReqContractorAttendanceList, getContractorAttendanceStatusString, contractorAttendanceStatusAttr, CONTRACTOR_ATTENDANCE_STATUS_EDIT } from '../../../../item/ItemContractorAttendance';
import { api_getContractorAttendanceList } from '../../../../api/apiContractorAttendancee';

export function ContractorAttendanceSOPList({ id, setIsLoading }) {
    const [tokenId, setTokenId] = useState("")

    const [companyId] = useState(getUserInfoCompanyId())
    const [contractorAttendanceList, setContractorAttendanceList] = useState([])

    const [page, setPage] = useState(1)
    const [limit] = useState(10)
    const [count, setCount] = useState(0)

    const [mReqContractorAttendanceList, setReqContractorAttendanceList] = useState({})

    useEffect(() => {
        if (id !== undefined && id !== tokenId) {
            var url = getval2Token("url", id)
            // console.log(url)
            setTokenId(id)
            var start = (url.page - 1) * limit;
            var mReqContractorAttendanceList = new ReqContractorAttendanceList({ companyId, start, limit })
            if (url === "") {
                toSearch({ items: mReqContractorAttendanceList, page: url.page })
            } else {
                mReqContractorAttendanceList.fromJson(url)
                // console.log(mReqRecruitmentContractorStatusList)
                setReqContractorAttendanceList(mReqContractorAttendanceList)
                toSearch({ items: mReqContractorAttendanceList, page: url.page })
            }
        }
    }, [id])
    // useEffect(() => {
    //     if (positionDemandList.length === 0) {
    //         toSearch({ page: 1 })
    //     }
    // }, [])


    function toSearch({ items, page = 1 }) {
        // console.log(items)
        var start = (page - 1) * limit;
        setPage(page)
        var mReqContractorAttendanceList = new ReqContractorAttendanceList({ companyId, start, limit })
        if (items !== undefined)
            mReqContractorAttendanceList.fromJson(items)
        mReqContractorAttendanceList.page = page
        setVal2Token("url", mReqContractorAttendanceList, id)
        setReqContractorAttendanceList(mReqContractorAttendanceList)
        getContractorAttendanceList(mReqContractorAttendanceList)
    }


    function getContractorAttendanceList(mReqContractorAttendanceList) {
        console.log(mReqContractorAttendanceList)
        if (setIsLoading !== undefined)
            setIsLoading(true)
        // console.log(mReqRecruitmentContractorStatusList)
        api_getContractorAttendanceList({
            mReqContractorAttendanceList,
            success: (obj) => {
                console.log(obj)
                setContractorAttendanceList(obj.list)
                setCount(obj.count.editCount)
                if (setIsLoading !== undefined)
                    setIsLoading(false)
            },
            failure: (err) => {
                console.log(err)
                if (setIsLoading !== undefined)
                    setIsLoading(false)
                //window.location.replace("/AdminManagerList");
            }
        })
    }

    function toAdd() {
        window.location.assign("/ContractorAttendanceSOPAdd/");
    }

    var title = '出勤登錄作業列表'
    var content =
        <>
            <div className="row">
                <div className="col-sm-12">
                    <EnableBadge text={"編輯中作業總數"} count={count} size={6} />
                    <AddButton name={"新增 出勤登錄作業"} action={toAdd} />
                </div>
            </div>
            <Space />
            <RecruitmentContractorStatusListBox list={contractorAttendanceList} srl={setContractorAttendanceList} count={count} page={page} sp={toSearch} />
        </>
    return (
        <>
            <RecruitmentContractorStatusListSearch action={toSearch} companyId={companyId} item={mReqContractorAttendanceList}/>
            <ContentBox title={title} titleSize={6} content={content} hasDrawer={false} />
            <SystemPromptInput />
        </>
    )
}

function RecruitmentContractorStatusListSearch({ action, item, companyId }) {
    const [mItem, setItem] = useState(null)
    const [contractorAttendanceSOPName, setContractorAttendanceSOPName] = useState("")
    const [contractorAttendanceSOPStatus, setContractorAttendanceSOPStatus] = useState(CONTRACTOR_ATTENDANCE_STATUS_EDIT)

    const [skillList, setSkillList] = useState([])

    useEffect(() => {
        // console.log(item)
        if (item !== undefined && mItem !== item) {
            setContractorAttendanceSOPName(item.contractorAttendanceSOPName || "")
            setContractorAttendanceSOPStatus(item.contractorAttendanceSOPStatus || "")
            setItem(item)
        }
    }, [item])

    useEffect(() => {
        getSkillList()
    }, [])

    useEffect(()=>{
        console.log(contractorAttendanceSOPStatus)
    },[contractorAttendanceSOPStatus])

    function getSkillList() {
        api_getSkill({
            success: (result) => {
                setSkillList(result.list)
            },
            failure: (err) => {

            }
        })
    }

    function toClear() {
        setContractorAttendanceSOPName("")
        setContractorAttendanceSOPStatus("")
    }

    function toSearch() {
        console.log(contractorAttendanceSOPStatus)
        var mReqContractorAttendanceList = new ReqContractorAttendanceList({
            companyId,
            contractorAttendanceSOPName,
            contractorAttendanceSOPStatus,
        })
        console.log(mReqContractorAttendanceList)
        action({ items: mReqContractorAttendanceList })
    }

    var content =
        <>
            <div className="row">
                <SingleInput title={"以作業名稱搜尋"} val={contractorAttendanceSOPName} action={setContractorAttendanceSOPName} size={4} />
                <SingleSelect title={"作業狀態"}
                    val={contractorAttendanceSOPStatus}
                    attr={contractorAttendanceStatusAttr}
                    action={setContractorAttendanceSOPStatus}
                    size={4}
                />
            </div>
            <div className="row m-t-sm m-t-sm">
                <div className="col-sm-4 col-sm-offset-5">
                    <CancelButton name={"清除"} action={toClear} />
                    <SearchButton action={toSearch} />
                </div>
            </div>

        </>
    return (
        <ContentBox hasTitle={false} content={content} hasDrawer={false} />
    )
}

function RecruitmentContractorStatusListBox({ list, srl, count, page, sp, isML, isAll }) {
    const [customerContractList, setCustomerContractList] = useState([])
    const [itemList, setItemList] = useState([])
    const [mPage, setPage] = useState(1)
    const [limit] = useState(10)
    const [mCount, setCount] = useState(0)

    const [iStart, setStart] = useState(0)
    const [iEnd, setEnd] = useState(0)

    useEffect(() => {
        if (list !== undefined && customerContractList !== list) {
            setCustomerContractList(list)
            setStart((page - 1) * limit + 1)
            setEnd((page - 1) * limit + list.length)
            setItemList(setTableList(list))
            setPage(page)
        }

        if (count !== mCount) {
            setCount(count)
        }
    }, [list, count])

    function setTableList(list) {
        var itemList = []
        for (var i = 0; i < limit; i++) {
            if (list[i] !== undefined) {
                itemList.push(<RecruitmentContractorStatusBox key={list[i].contractorAttendanceId} item={list[i]} isML={isML} isAll={isAll} />)
            } else {
                itemList.push(<RecruitmentContractorStatusBox key={"resumeId" + i} />)
            }
        }
        return itemList
    }

    function sPage(p) {
        console.log("pagechange" + p)
        if (p !== page) {
            sp({ page: p })
            setPage(p)
        }
    }

    if (itemList.length === 0) {
        return (<></>)
    } else {
        //console.log(managerList)
        return (
            <div id="editable_wrapper" className="form-inline dt-bootstrap">
                <div className="row">
                    <div className="col-sm-12">
                        <table className="table table-striped table-bordered table-hover  dataTable">
                            <thead>
                                <tr role="row">
                                    <th className="text-center sorting col-sm-2">建立</th>
                                    <th className="text-center sorting col-sm-5">作業名稱</th>
                                    <th className="text-center sorting col-sm-3">起迄</th>
                                    <th className="text-center sorting col-sm-2">狀態</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    itemList.map((item) => (
                                        item
                                    ))
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
                {
                    mCount === 0 ? <></> : <Pagination p={mPage} l={limit} c={mCount} sp={sPage} s={iStart} e={iEnd} />
                }
            </div>
        )
    }

}

function RecruitmentContractorStatusBox({ item, isML, isAll }) {
    const [mItem, setItem] = useState({})
    const [companyId] = useState(getUserInfoCompanyId())

    const [contractorAttendanceId, setContractorAttendanceId] = useState("")
    const [contractorAttendanceSOPName, setContractorAttendanceSOPName] = useState("")
    const [creatAt, setCreatAt] = useState("")
    const [dates, setDates] = useState("")
    const [status, setStatus] = useState("")


    useEffect(() => {
        if (item !== undefined && item !== mItem) {
            console.log(item)
            setItem(item)
            setContractorAttendanceId(item.contractorAttendanceId)
            setCreatAt(moment(item.creatAt).format('YYYY/MM/DD HH:mm:ss'))
            setContractorAttendanceSOPName(item.contractorAttendanceSOPName)
            const startDate = moment(item.startDate).format('YYYY/MM/DD')
            const endDate = moment(item.endDate).format('YYYY/MM/DD')
            if(startDate)
                setDates(startDate+"～"+endDate)
            setStatus(getContractorAttendanceStatusString(item.contractorAttendanceSOPStatus))
            
        }
    }, [item])

    return (
        <tr role="row">
        <td className="text-center">{creatAt}</td>
            <td className="text-center">
                <SingleLink link={"ContractorAttendanceEdit"}
                    name={contractorAttendanceSOPName}
                    Key={"contractorAttendanceId"}
                    val={{contractorAttendance: item}} >
                </SingleLink>
            </td>
            {/* <td className="text-center"><a href="#A" onClick={e => toDetail()}>{name}</a></td> */}
            <td className="text-center">{dates}</td>
            <td className="text-center">{status}&nbsp;</td>
        </tr>
    )
}
